import {BaseStore} from '@/stores/baseStore';
import voucherAPI from '@/apis/lg/voucherAPI';
// TODO => hoàn thiện các action trên chứng từ
export class BaseVoucherStore extends BaseStore {
  constructor(api) {
    super(api);
    this.state.loading = true;
    this.action = {
      ...this.action,
      ...{
        deleteRelation: async function (payload) {
          return await api.deleteRelation(payload);
        },
        changeStatusPosted: async function () {},
        posted: async function (payload) {
          const res = await voucherAPI.posted(payload);
          if (res.is_success == true) {
            this.updatedItemPosted([payload.data], true);
          }
          return res;
        },
        unPosted: async function (payload) {
          const res = await voucherAPI.unPosted(payload);
          if (res.is_success == true) {
            this.updatedItemPosted([payload.data], false);
          }
          return res;
        },
        postBatch: async function (payload) {
          const res = await voucherAPI.postBatch(payload);
          let dataSuccess = payload.data.slice();
          if (res && res.length > 0) {
            const listIndex = new Set(res.map(x => x.Index));
            dataSuccess = payload.data.filter((value, i) => !listIndex.has(i));
          }
          if (dataSuccess.length > 0) {
            this.updatedItemPosted(dataSuccess, true);
          }
          return res;
        },
        unPostBatch: async function (payload) {
          const res = await voucherAPI.unPostBatch(payload);
          let dataSuccess = payload.data.slice();
          if (res && res.length > 0) {
            const listIndex = new Set(res.map(x => x.Index));
            dataSuccess = payload.data.filter((value, i) => !listIndex.has(i));
          }
          if (dataSuccess.length > 0) {
            this.updatedItemPosted(dataSuccess, false);
          }
          return res;
        },
        postMulti: async function (payload) {
          const res = await voucherAPI.postMulti(payload);
          return res;
        },
        unPostMulti: async function (payload) {
          const res = await voucherAPI.unPostMulti(payload);
          return res;
        },
        /**
         * Thực hiện bỏ ghi sổ khi thực hiện chọn tất
         * HQMINH 01.04.2024
         */
        postMultiSelectedAll: async function (payload) {
          const res = await api.postMultiSelectedAll(payload);
          return res;
        },
        /**
         * Thực hiện bỏ ghi sổ khi thực hiện chọn tất
         * HQMINH 01.04.2024
         */
        unPostMultiSelectedAll: async function (payload) {
          const res = await api.unPostMultiSelectedAll(payload);
          return res;
        },
        /**
         * Thực hiện xóa khi chọn tất cả
         * HQMINH 01.04.2024
         */
        deleteMultiSelectedAll: async function (payload) {
          const res = await api.deleteMultiSelectedAll(payload);
          return res;
        },
        deleteRelation: async function (payload) {
          return await api.deleteRelation(payload);
        },
        updatedItemPosted: function (data, value) {
          const keyField = this._config.key;
          const postedField = this._config.posted;

          if (data && data.length) {
            for (let i = 0; i < data.length; i++) {
              if (keyField && postedField) {
                const id = data[i];
                const objValue = {};
                objValue[postedField] = value;

                for (let j = 0; j < this.items.length; j++) {
                  const item = this.items[j];

                  if (item[keyField] === id?.refId) {
                    Object.assign(item, objValue);
                    // break;
                  }
                }
              }
            }
          }
        },
      },
    };
  }
}
